<template>
  <div>
    <nav-breadcrumb :menu="[{label: userId? '编辑用户' : '新增用户'}]"/>
    <el-form :model="userInfo" :rules="formRules" ref="userInfoForm" label-width="150px">
      <el-row :gutter="10" class="bg-purple xzpadd10">
        <el-col :span="24">
          <div class="Htitle-text">用户信息</div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户名" prop="u__userCode">
            <el-input v-model.trim="userInfo.u__userCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="姓名" prop="u__userName">
            <el-input v-model.trim="userInfo.u__userName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="userId==''">
          <el-form-item label="初始密码" prop="u__password">
            <el-input v-model.trim="userInfo.u__password"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电话" prop="u_telephone">
              <el-input v-model.trim="userInfo.u__telephone"></el-input>
          </el-form-item>
      </el-col>
          <el-col :span="12">
              <el-form-item label="邮箱" prop="u__email">
                  <el-input v-model.trim="userInfo.u__email"></el-input>
              </el-form-item>
          </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="u__disabled">
            <el-select v-model.trim="userInfo.u__disabled">
              <el-option label="启用" value="N"></el-option>
              <el-option label="禁用" value="Y"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属部门" prop="du__departmentId">
            <el-select v-model.trim="userInfo.du__departmentId">
              <el-option :label="item.label" :value="item.value" v-for="(item,idx) in departmentListOptions" :key="idx"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="bg-purple" style="padding:5px 15px;">
        <el-col>
          <div class="Htitle-text">权限设置</div>
          <p class="Htitle-text-bz">权限与角色关联，选择该账号的角色可以完成权限的配置</p>
          <el-form-item label="角色权限" prop="roleIds">
            <el-checkbox-group v-model="userInfo.roleIds">
              <el-checkbox :label="item.r__roleId" v-for="(item ,idx) in roleList" :key="idx">{{item.r__roleName}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="xzmt tr">
            <el-button type="primary" @click="submitForm('userInfoForm')">保存</el-button>
            <el-button plain @click="$router.go(-1)">返回</el-button>
      </div>
    </el-form>


  </div>
</template>
<script>
  import xhr from '@/utils/xhr'

  export default {
    data() {
      return {
        userId: '',
        userInfo: {
          roleIds: []
        },
        roleList: {},
        departmentListOptions: [],
        formRules: {
          u__userCode: [
            {
              required: true,
              message: '用户名必填！',
            }
          ],
          u__userName: [
            {
              required: true,
              message: '姓名必填！',
            }
          ],
          u__password: [
            {
              required: true,
              message: '密码不能为空！',
            }
          ],
          du__departmentId: [
            {
              required: true,
              message: '所属部门不能为空！'
            }
          ],
          u__disabled: [
            {
              required: true,
              message: '状态不能为空！',
            }
          ],
          roleIds: [
            {
              required: true,
              message: '登录类型必选！',
            }
          ]
        }
      };
    },
    mounted: function () {
      this.userId = this.$route.query.userId || ''
      this.userId && this.getUserInfo()
      this.getRoleList()
      this.getConfigDepartmentList()
    },
    methods: {
      //获取用户信息
      getUserInfo: function () {
        xhr.getUser({
          'u.userId': this.userId
        }, res=> {
          let userInfo = res.data.data
          userInfo.roleIds = []
          userInfo.roleIds = userInfo.detail.map(item => item.ur__roleId).filter(n => n)
          this.userInfo = userInfo
        })
      },
      //获取角色列表
      getRoleList: function () {
        xhr.getRoleList({ pageSize:0}, res=> {
          this.roleList = res.data.data
        })
      },
      getConfigDepartmentSelectOptions: function(arr) {
        arr.forEach(item=>{
          this.departmentListOptions.push({
            label: item.name,
            value: item.id
          })
          if( Array.isArray(item.dept)) {
            this.getConfigDepartmentSelectOptions(item.dept)
          }
        })
      },
      getConfigDepartmentList: function() {
        xhr.getConfigDepartmentList(
          {
            'd.parentId': '',
            pageSize: 100
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.departmentListOptions = res.data.data.map(item=>{
                  return {
                    label: item.d__departmentName,
                    value:item.d__departmentId,
                  }
                })
              }
            }catch (e) {

            }
          }
        )
      },
      //保存操作
      submitForm: function (formName) {
        let userInfo = this.userInfo
        this.$refs[formName].validate(valid=> {
          if (valid) {
            userInfo.detail = userInfo.roleIds.map(item => {
              return {
                "detail.checked": true,
                "ur.roleId": item
              }
            })
            userInfo.u__checked = true
            xhr.updateUser(userInfo, res => {
              if (this.userId) {
                this.getUserInfo()
              } else {
                this.$refs[formName].resetFields();
              }
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/lender/setting/ConfigUserEdit.vue